
import VueHorizontal from "vue-horizontal";
export default {
  components: { VueHorizontal },
  props: {
    listName: {
      type: String,
      default: "options",
    },
    value: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      left: 0,
      originX: 0,
      originLeft: 0,
      limit: 0,
      packageID: null,
      options: [
        {
          name: "name",
          label: "Naziv paketa",
          type: "tipTap",
        },
        {
          name: "id",
          label: "id* (provjerit s Tomom koji ID je potreban za koji paket)",
          type: "text",
        },
        {
          name: "price",
          label: "Mjesecna cijena",
          type: "text",
        },
        {
          name: "features",
          label: "Znacajke",
          type: "tipTap",
        },
        {
          name: "limit",
          label: "Ogranicenje* (potrebno za dodavanje sudionika)",
          type: "text",
        },
      ],
    };
  },
  computed: {
    vModel: {
      get() {
        this.getLimit();
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  methods: {
    getLimit() {
      if (
        this.$refs.tryForFreePackages &&
        this.$refs.tryForFreePackages.items &&
        this.$refs.tryForFreePackages.items.length
      ) {
        const items = this.$refs.tryForFreePackages.items;
        items.forEach((item) => {
          if (item.name === this.value) {
            this.limit = item.limit;
          }
        });
      }
    },
    clean(string) {
      if (!string) return;
      const div = document.createElement("div");
      div.innerHTML = string;
      if (!div.textContent) return string;
      else return div.textContent;
    },

    onScroll({ left }) {
      this.left = left;
    },
    onMouseDown(e) {
      this.originX = e.pageX;
      this.originLeft = this.left;

      window.addEventListener("mouseup", this.onMouseUp);
      window.addEventListener("mousemove", this.onMouseMove);
    },
    onMouseUp() {
      window.removeEventListener("mouseup", this.onMouseUp);
      window.removeEventListener("mousemove", this.onMouseMove);
    },
    onMouseMove(e) {
      const offset = e.pageX - this.originX;
      const left = this.originLeft - offset;

      this.$refs.horizontal.scrollToLeft(left, "auto");
    },
  },
};
